import type { PlazaAvatar } from "./types";
export type GalleryImage = { label: string; url?: string };

export function portraitViews(avatar: Pick<PlazaAvatar, "imageUrl" | "leftImageUrl" | "rightImageUrl">): GalleryImage[] {
  const seen = new Set<string>();
  return [
    { label: "正面", url: avatar.imageUrl },
    { label: "左侧面", url: avatar.leftImageUrl },
    { label: "右侧面", url: avatar.rightImageUrl },
  ].map(image => {
    const identity = image.url?.split("?")[0];
    if (!identity || seen.has(identity)) return { label: image.label };
    seen.add(identity);
    return image;
  });
}
